import { getInitials, avatarColorClass } from "../lib/avatar";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "./ui/tooltip";

// Stacked avatars for a task's responsables: photo when set, colored initials
// otherwise (same getInitials/avatarColorClass pair as Users/Activity, so a
// person gets the same color everywhere). The name is in a tooltip plus
// `aria-label`/`role="img"` for screen readers; touch and keyboard users get
// the full names in the detail view the row opens.
const MAX_VISIBLE = 3;

function Avatar({ name, avatarUrl, colorSeed }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          role="img"
          aria-label={name}
          className={`w-6 h-6 rounded-full flex items-center justify-center text-2xs font-semibold ring-2 ring-white overflow-hidden shrink-0 ${avatarUrl ? "bg-slate-100" : avatarColorClass(colorSeed)}`}
        >
          {avatarUrl ? <img src={avatarUrl} alt="" className="w-full h-full object-cover" /> : getInitials(name)}
        </div>
      </TooltipTrigger>
      <TooltipContent>{name}</TooltipContent>
    </Tooltip>
  );
}

// `resolveUser(id)` -> {name, avatar_url} | null. Supplied by the caller,
// since resolving "self" (not always in `directory`) is page-specific.
export default function AssigneeAvatars({ userIds, resolveUser }) {
  const ids = userIds || [];
  if (ids.length === 0) return <span className="text-sm text-slate-400">Aucun responsable</span>;

  const resolved = ids.map((id) => ({ id, ...(resolveUser(id) || {}) }));
  const visible = resolved.slice(0, MAX_VISIBLE);
  const overflow = resolved.slice(MAX_VISIBLE);

  return (
    <TooltipProvider delayDuration={200}>
      <div className="flex items-center -space-x-1.5">
        {visible.map((u) => (
          <Avatar key={u.id} name={u.name || "Utilisateur"} avatarUrl={u.avatar_url} colorSeed={u.id} />
        ))}
        {overflow.length > 0 && (
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                role="img"
                aria-label={overflow.map((u) => u.name || "Utilisateur").join(", ")}
                className="w-6 h-6 rounded-full flex items-center justify-center text-2xs font-semibold ring-2 ring-white bg-slate-100 text-slate-600 shrink-0"
              >
                +{overflow.length}
              </div>
            </TooltipTrigger>
            <TooltipContent>{overflow.map((u) => u.name || "Utilisateur").join(", ")}</TooltipContent>
          </Tooltip>
        )}
      </div>
    </TooltipProvider>
  );
}
